import { createSlice } from '@reduxjs/toolkit'
import { StoreStatus } from 'common/utils/types'

import { getLookup } from './lookup.service'
import { type LookupItem } from './lookup.types'

export interface VendorState {
  lookup: Record<string, LookupItem[]>
  getLookup: StoreStatus
}

const initialState: VendorState = {
  lookup: {},
  getLookup: StoreStatus.Idle,
}

export const LookupSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    resetState: (state) => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getLookup.pending, (state, { payload }) => ({
      ...state,
      getLookup: StoreStatus.Loading,
    }))
    builder.addCase(getLookup.fulfilled, (state, { payload }) => ({
      ...state,
      lookup: {
        ...state.lookup,
        [payload.value]: payload.data ?? [],
      },
      getLookup: StoreStatus.Succeeded,
    }))
    builder.addCase(getLookup.rejected, (state) => ({
      ...state,
      getLookup: StoreStatus.Failed,
    }))
  },
})

export default LookupSlice.reducer
